"use client"

import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"

export type DoujinsCategory =
  | ""
  | "featured"
  | "top-rated"
  | "original-series"
  | "series"
  | "artists"
  | "movies"

interface DoujinsCategoryTabsProps {
  value: DoujinsCategory
  onChange: (value: DoujinsCategory) => void
}

// Mirrors doujins.com's own top-level nav. These were previously six fake
// "gallery" posts in the results grid, each a hardcoded base64 SVG rectangle
// with the section name baked into the image — so browsing the source meant
// landing on a screen of six flat colour blocks and clicking one before any
// content appeared at all. Same conversion already done for HentaiEra and
// LewdVault (see hentaiera-category-tabs.tsx / lewdvault-sort-tabs.tsx).
//
// "" is Recent rather than "All": doujins.com's front page IS the recent
// feed, and the route maps both "" and the old "doujins" value to the same
// URL, so the empty default already lands there. Labelling it "All" would
// imply a merged view the site doesn't actually have.
//
// Series and Artists are listing pages — picking one shows a grid of series
// or artists, which are themselves navigable (the route re-marks those as
// isCategory and the existing nested navigation drills into them). That
// two-level behaviour is unchanged; only the top-level entry point moved
// from tiles to this strip.
//
// Movies is new here: the route has always supported category=movies but no
// tile was ever generated for it, so it was unreachable from the UI.
const OPTIONS: { value: DoujinsCategory; label: string }[] = [
  { value: "", label: "Recent" },
  { value: "featured", label: "Featured" },
  { value: "top-rated", label: "Top Rated" },
  { value: "original-series", label: "Original Series" },
  { value: "series", label: "By Series" },
  { value: "artists", label: "By Artists" },
  { value: "movies", label: "Movies" },
]


export function DoujinsCategoryTabs({ value, onChange }: DoujinsCategoryTabsProps) {
  return (
    <div className={SOURCE_FILTER_ROW}>
      {OPTIONS.map((opt) => {
        const isActive = value === opt.value
        return (
          <button
            key={opt.value || "recent"}
            onClick={() => onChange(opt.value)}
            className={sourceFilterPill(isActive)}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
